import Button from "lib/components/atomic/Button";
import TextField from "lib/components/atomic/TextField";
import { Form } from "lib/components/Form";
import FormControl from "lib/components/Form/FormControl";
import Image from "next/image";
import { useEffect, useState } from "react";
import Countdown from "lib/components/atomic/Countdown";
import { SecureIcon } from "lib/components/Icon";
import Spacer from "lib/components/Form/Spacer";
import useVerifyOtp from "lib/hooks/register/useVerifyOtp";
import { useSelector } from "react-redux";
import { getUser } from "redux/reducers/userSlice";
import { useRouter } from "next/router";
import { authLayout } from "pages/layout/auth";
import { ButtonSpinner } from "lib/components/atomic/Spinner/Spinner";
interface VerifyOtpProps {
  nextTab?: () => void;
  prevTab?: () => void;
}

function VerifyOtp({ nextTab, prevTab }: VerifyOtpProps) {
  const { loading, verifyOtp, success } = useVerifyOtp();
  const user = useSelector(getUser);
  const router = useRouter();
  const query = router.query;

  const totalNoOfField = 6;

  const [iat, setIat] = useState(() => Math.floor(Date.now() / 1000));
  const [exp, setExp] = useState(() => Math.floor(Date.now() / 1000) + 1 * 60);

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const target = e.target as HTMLFormElement;
    if (e.key === "Delete" || e.key === "Backspace") {
      const next = target.tabIndex - 2;
      if (next > -1) {
        target.form.elements[next].focus();
      }
    } else {
      const next = target.tabIndex;
      if (next < totalNoOfField) {
        target.form.elements[next].focus();
      }
    }
  };
  useEffect(() => {
    if (nextTab && success) nextTab();
  }, [nextTab, success]);

  return (
    <div className="flex  justify-between py-13 px-5 items-center max-w-screen-sm">
      <div className="flex-1 ">
        <div className=" mr-auto">
          <h1 className="text-3xl mb-3 text-medium">Enter Verification Code</h1>
          <p className=" text-gray mb-8">
            Please enter the 6 digit verification code sent to your number{" "}
            <span className="font-bold text-gray-800">
              {user?.userData?.mobile}
            </span>{" "}
            <p
              className="text-sm text-info cursor-pointer"
              onClick={() => {
                // query?.user && query.user === "legacy"
                //   ? router.push("/legacyuser/mobileupdate")
                //   : router.push("/register");
                prevTab && prevTab();
              }}
            >
              Change Number
            </p>
          </p>
          <Form
            onSubmit={(value) => {
              verifyOtp(
                {
                  otpValue: Object.values(value).join(""),
                },
                {
                  user: query?.user,
                },
              );
            }}
          >
            <Spacer className="flex justify-between">
              {Array.from(Array(totalNoOfField).keys()).map((field) => (
                <FormControl key={field} required name={`otp${field}`}>
                  <TextField
                    type="tel"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="bg-gray-50 border-gray-400 h-10 rounded-lg mr-2 md:mr-5"
                    inputStyle="text-center text-xl text-gray-600 w-4 p-0"
                    maxLength={1}
                    tabIndex={field + 1}
                    onKeyUp={handleKeyPress}
                  />
                </FormControl>
              ))}
            </Spacer>
            <Button
              className="mt-16 flex justify-center gap-3 bg-primary hover:bg-primary-600"
              type="submit"
              variant="PRIMARY"
              block
              disabled={loading}
            >
              {loading ? (
                <div>
                  <span className="mr-3">Verifying Your Otp...</span>
                  <ButtonSpinner />
                </div>
              ) : (
                <>
                  <SecureIcon className="inline-block" />
                  <span>Verify and Create Account</span>
                </>
              )}
            </Button>
          </Form>

          <p className="text-sm text-center text-gray-700 pt-10">
            Didn&apos;t recieve code ?
            <Countdown seconds={exp - iat} />
          </p>
        </div>
      </div>
    </div>
  );
}

export default VerifyOtp;
